import Vue from "vue";
import App from "./views/App.vue";
import router from "./routes";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import "element-ui/lib/theme-chalk/index.css";
import filters from "@/filters";
const moment = require("moment");

Vue.config.productionTip = false;
Vue.use(ElementUI, { locale });
Vue.use(filters);
Vue.use(require("vue-moment"), {
  moment
});

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
